import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Plus } from 'lucide-react';
export function NewChatButton({ onSelect, disabled, label = 'New Chat', variant = 'default' }) {
    const handleClick = ()=>onSelect();
    if (variant === 'inline') {
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            onClick: handleClick,
            disabled: disabled,
            className: "absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 disabled:opacity-50",
            "aria-label": "Start chat",
            children: /*#__PURE__*/ _jsx(Plus, {
                className: "w-4 h-4"
            })
        });
    }
    if (variant === 'primary') {
        return /*#__PURE__*/ _jsxs(Button, {
            size: "sm",
            onClick: handleClick,
            disabled: disabled,
            "data-testid": Testids.projectChats.createChatButton,
            children: [
                /*#__PURE__*/ _jsx(Plus, {
                    className: "w-4 h-4 mr-1"
                }),
                disabled ? 'Creating...' : label
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Button, {
        variant: "ghost",
        size: "sm",
        onClick: handleClick,
        disabled: disabled,
        "data-testid": Testids.projectChats.createChatButton,
        className: "text-gray-500 hover:text-gray-700",
        children: [
            /*#__PURE__*/ _jsx(Plus, {
                className: "w-4 h-4 mr-1"
            }),
            disabled ? 'Creating...' : label
        ]
    });
}
